/* eslint-disable */

// @ts-nocheck
import React, { useState, useRef } from "react";
import { LivestreamLayoutCommonProps } from "../../../types";
import * as Styled from "./Layout8.styled";
import { EventCard } from "../../event-card";
import { ArrowLeft, ArrowRight } from 'react-bootstrap-icons';
import LayoutModal from "../../event-card/FullScreenModal";
import { LayoutHeader } from "../../layouts/LayoutHeader";
import { FilterOption } from "../ToggleFilter/ToggleFilter";
import { filterEventsByType } from "../../../libs/utils/eventFilter";
import { scrollOnce, startContinuousScroll, stopContinuousScroll } from "../../../libs/utils";
import { EmptyLiveStreams } from "../../empty-state";

export const Layout8: React.FC<LivestreamLayoutCommonProps> = ({
    events,
    sessionToken,
    isSignedIn,
    activePlans,
    hasFullAccess,
    freeTrialPlanIds,
    onWatchClick
}) => {
    // Layout not yet implemented/planned to implement
    return <></>;
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const [selectedOption, setSelectedOption] = useState<FilterOption>('All');
    // const scrollRef = useRef<HTMLDivElement>(null);
    // const scrollIntervalRef = useRef<NodeJS.Timeout | null>(null);

    // const handleSeeAllClick = () => {
    //     setIsModalOpen(true);
    // };

    // const handleCloseModal = () => {
    //     setIsModalOpen(false);
    // };

    // const filteredEvents = filterEventsByType(events, selectedOption);

    // if (!events.length) return <EmptyLiveStreams />;

    // return (
    //     <>
    //         <LayoutHeader
    //             title={'Live Streams'}
    //             itemCount={filteredEvents?.length}
    //             selectedOption={selectedOption}
    //             setSelectedOption={setSelectedOption}
    //             onSeeAll={handleSeeAllClick}
    //             padding="20px 10px 20px 0px"
    //             marginTop="0px"
    //             showToggle={true}
    //         />
    //         {filteredEvents.length === 0 ? (
    //             <Styled.EmptyState>
    //                 There are no events currently streaming. Please check back later for updates.
    //             </Styled.EmptyState>
    //         ) : (
    //             <Styled.Container>
    //                 {filteredEvents.length > 3 && (
    //                     <Styled.ScrollControls>
    //                         <Styled.ScrollButton
    //                             onClick={() => scrollOnce(scrollRef, "left")}
    //                             onMouseDown={() => startContinuousScroll(scrollRef, "left", scrollIntervalRef)}
    //                             onMouseUp={() => stopContinuousScroll(scrollIntervalRef)}
    //                             onMouseLeave={() => stopContinuousScroll(scrollIntervalRef)}
    //                             title="Scroll Left"
    //                         >
    //                             <ArrowLeft size={24} />
    //                         </Styled.ScrollButton>
    //                         <Styled.ScrollButton
    //                             onClick={() => scrollOnce(scrollRef, "right")}
    //                             onMouseDown={() => startContinuousScroll(scrollRef, "right", scrollIntervalRef)}
    //                             onMouseUp={() => stopContinuousScroll(scrollIntervalRef)}
    //                             onMouseLeave={() => stopContinuousScroll(scrollIntervalRef)}
    //                             title="Scroll Right"
    //                         >
    //                             <ArrowRight size={24} />
    //                         </Styled.ScrollButton>
    //                     </Styled.ScrollControls>
    //                 )}

    //                 <Styled.HorizontalScroll ref={scrollRef}>
    //                     {filteredEvents.map((item: any) => (
    //                         <Styled.ScrollItem key={item.id}>
    //                             <EventCard
    //                                 event={item}
    //                                 isSignedIn={isSignedIn}
    //                                 hasEligiblePlan={
    //                                     isSignedIn &&
    //                                     (!!item.planDetails.length
    //                                         ? !!activePlans.filter((memberPlan) =>
    //                                             item.planDetails?.some(
    //                                                 (itemPlan: any) =>
    //                                                     itemPlan?.id === memberPlan.id
    //                                             )
    //                                         ).length ||
    //                                         freeTrialPlanIds.includes(
    //                                             item.planDetails[0]?.id
    //                                         ) ||
    //                                         hasFullAccess
    //                                         : true)
    //                                 }
    //                                 onWatchClick={onWatchClick}
    //                             />
    //                         </Styled.ScrollItem>
    //                     ))}
    //                 </Styled.HorizontalScroll>
    //             </Styled.Container>
    //         )}

    //         <LayoutModal
    //             show={isModalOpen}
    //             onHide={handleCloseModal}
    //             filteredLiveEvents={events}
    //             isSignedIn={isSignedIn}
    //             activePlans={activePlans}
    //             hasFullAccess={hasFullAccess}
    //             freeTrialPlanIds={freeTrialPlanIds}
    //             onWatchClick={onWatchClick}
    //         />
    //     </>
    // );
};
